module Meevo.Components.GlobalNav {
    "use strict";

    export class MeevoEnhancedLocationDropdown implements angular.IDirective {
        restrict = "A";
        scope = false;

        link = (scope: any, ele: JQuery) => {
            ele.bind("click", (event: JQueryEventObject) => {
                event.stopPropagation();
                const currentLocationName: string = (scope.main && scope.main.locationName) || "";

                if (this.$mdMedia("xs")) {
                    this.openBottomSheet(currentLocationName);
                } else {
                    this.openPanel(ele, currentLocationName);
                }
            });
        }

        private openPanel(ele: JQuery, currentLocationName: string): void {
            const position = this.$mdPanel.newPanelPosition()
                .relativeTo(ele)
                .addPanelPosition(
                    this.$mdPanel.xPosition.ALIGN_END,
                    this.$mdPanel.yPosition.BELOW
                );

            this.$mdPanel.open({
                attachTo: angular.element(document.body),
                controller: "Meevo.Components.GlobalNav.EnhancedLocationDropdownController",
                controllerAs: "ctrl",
                templateUrl: "app/components/globalNav/enhancedLocationDropdown.html",
                panelClass: "enhanced-location-dropdown-panel",
                position: position,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                zIndex: 200,
                locals: {
                    currentLocationName: currentLocationName
                }
            }).then((panelRef: any) => {
                panelRef.config.position._absolute = true;
            });
        }

        private openBottomSheet(currentLocationName: string): void {
            this.$mdBottomSheet.show({
                templateUrl: "app/components/globalNav/enhancedLocationDropdownSheet.html",
                controller: "Meevo.Components.GlobalNav.EnhancedLocationDropdownController",
                controllerAs: "ctrl",
                clickOutsideToClose: true,
                locals: {
                    currentLocationName: currentLocationName
                }
            });
        }

        static factory(): angular.IDirectiveFactory {
            const directive = ($mdPanel: any, $mdBottomSheet: any, $mdMedia: any) => {
                return new MeevoEnhancedLocationDropdown($mdPanel, $mdBottomSheet, $mdMedia);
            };
            directive.$inject = ["$mdPanel", "$mdBottomSheet", "$mdMedia"];
            return directive;
        }

        constructor(
            private $mdPanel: any,
            private $mdBottomSheet: any,
            private $mdMedia: any
        ) {}
    }

    angular.module("meevo.components.globalNav")
        .directive("meevoEnhancedLocationDropdown", MeevoEnhancedLocationDropdown.factory());
}
